/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 07.09.2016.
 */

import Toasts from './toasts';

export default Toasts;



// WEBPACK FOOTER //
// ./src/containers/Toasts/index.js